<template>
    <div
      class="eventmap-viewer"
      :style="{
        'aspect-ratio': aspectRatio,
      }"
    >
      <EventmapSVG
        v-if="eventmap?.id"
        :eventmap="eventmap"
        :selectedLocation="selectedLocation"
        ref="eventmapSVG"
        :lockSelected="false"
        :activePath="activePath"
        :isEditingLocation="false"
        @svgReady="zoomSoon"
        flashSelectedLocation
        :showZoomInstructions="showZoomInstructions"
      />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';

const props = defineProps({
  eventmapId: Number,
  locationId: Number,
  lockAspectRatio: Boolean,
  eventmapRoute: String,
  showZoomInstructions: {
    type: Boolean,
    default: false,
  },
});

const selectedLocation = ref(null);

const activePath = ref(null);

const eventmapSVG = ref(null);

const eventmap = ref(null);

const aspectRatio = ref('16 / 9');

axios.get(props.eventmapRoute)
  .then((response) => {
    eventmap.value = response.data.eventmap;
    if (props.lockAspectRatio === false) {
      aspectRatio.value = `${eventmap.value.width} / ${eventmap.value.depth}`;
    }
  });

const zoomSoon = () => {
  if (props.locationId) {
    setTimeout(() => {
      const location = eventmap.value.locations.find((loc) => loc.id === props.locationId);
      eventmapSVG.value.zoomToLocation(location);
      selectedLocation.value = location;
    }, 1000);
  }
};

</script>
<style scoped>
.eventmap-viewer {
  width: 100%;
  max-width: 1280px;
  height: auto;
  max-height: 600px;
  margin: 0 auto;
  position: relative;
  border: 2px solid #fff;
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.eventmap-viewer::after {
  content: '';
  box-shadow: inset 0 0 20px 4px rgb(0 0 0 / 12%);
  display: block;
  position: absolute;
  inset: 0;
  border-radius: var(--radius);
  overflow: hidden;
  pointer-events: none;
}
</style>
